module.exports = __webpack_public_path__ + "static/media/09 Trumpet Region 20 Scales.a6534cd4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/middleSchool/scales/09 Trumpet Region 20 Scales.pdf
// module id = 282
// module chunks = 0